import { Project, User } from 'api/models';
import { MeteorObservable } from 'meteor-rxjs';
import { Projects, Users } from 'api/collections';
import * as permissions from './permissions';
import * as _ from 'lodash';
import { HttpService } from './httpService';
import { Injectable, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { MeteorUser } from './congito';

@Injectable()
export class ProjectService {
  constructor(
    public httpService: HttpService
  ) {}

  getProjectMembers(project): User[] {
    const memberIds = (project && project.memberIds) || [];
    const members = Users.find({
      _id: {
        $in: memberIds,
      },
    }, {sort: {'profile.name': 1}}).fetch();
    return _.orderBy(members, [
      user => project && permissions.isProjectManager(project, user),
      'profile.name',
    ], ['desc', 'asc']);
  }

  getProjectManagers(project): User[] {
    if (!project || !project.pmIds) {
      return;
    }

    const { pmIds } = project;
    return Users.find({
      _id: {
        $in: pmIds,
      },
    }, {sort: {'profile.name': 1}}).fetch();
  }

  getProject(projectId: string): Project | void {
    if (!projectId) {
      return;
    }
    // MeteorObservable.subscribe('projectDetails', projectId).subscribe();
    this.httpService.MeteorSubscribe('projectDetails', projectId);

    return Projects.findOne({_id:projectId});
  }

  subscribeActiveProjectMembers() {
    return this.getProjectMembers(this.subscribeActiveProject());
  }

  subscribeActiveProjectManagers() {
    return this.getProjectManagers(this.subscribeActiveProject());
  }

  subscribeActiveProject(): Project | void {
    const activeProjectId = this.getActiveProjectId();

    if (!activeProjectId) {
      return;
    }

    return this.getProject(activeProjectId);
  }

  getActiveProjectId(): string {
    const viewer = MeteorUser();
    const activeProjectId = viewer && viewer.profile && viewer.profile.activeProjectId;
    return activeProjectId || '';
  }
}



// WEBPACK FOOTER //
// ./src/services/projectData.ts